<script>
	import DayEvent from "./DayEvent.svelte";
	import { isSameDay, isToday } from "date-fns";
	import { calculateTimeLinePosition } from "@xbs/lib-scheduler";

	export let timeScale = [];
	export let events = [];
	export let cellCss;
	export let date;
	export let selected;
	export let calendars = [];
	$: sorted = events.filter(e =>
		isSameDay(e.eventData.start_date, date.value)
	);
	$: today = isToday(date.value);

	let pos;

	$: if (today) {
		pos = calculateTimeLinePosition(timeScale);
		setInterval(() => {
			pos = calculateTimeLinePosition(timeScale);
		}, 1200);
	} else {
		pos = null;
	}

</script>

<div class="wx-event-calendar-wrapprer">
	{#each timeScale as hourCell}
		<div
			class="wx-event-calendar-time {cellCss(hourCell.label)}"
			data-cell="{date.value?.valueOf()}:{hourCell.value}"
			data-drag="both"
			class:wx-event-calendar-today={today} />
	{/each}
	{#each sorted as event (event.eventData.id)}
		<DayEvent {event} {calendars} {selected} />
	{/each}
	{#if pos}
		<div class="wx-event-calendar-time-line-wrapper" style="top: {pos}">
			<div class="wx-event-calendar-time-circle" />
			<div class="wx-event-calendar-time-line" />
		</div>
	{/if}
</div>

<style>
	.wx-event-calendar-wrapprer {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		flex-shrink: 0;
		height: 100%;
		position: relative;
		overflow: visible;
	}
	.wx-event-calendar-time {
		width: 100%;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-right: var(--wx-border);
		border-bottom: var(--wx-border);
		flex-grow: 0;
		flex-shrink: 0;
		height: var(--wx-event-calendar_hour-cell-height);
	}

	.wx-event-calendar-today {
		background-color: var(--wx-background-alt);
	}
	.wx-event-calendar-time-line-wrapper {
		position: absolute;
		display: flex;
		align-items: center;
		left: -2px;
		width: 100%;
		pointer-events: none;
	}
	.wx-event-calendar-time-circle {
		background: #ea4335;
		-webkit-border-radius: 50%;
		border-radius: 50%;
		content: "";
		position: absolute;
		height: 12px;
		margin-left: -6.5px;
		width: 12px;
		z-index: 505;
	}

	.wx-event-calendar-time-line {
		max-width: 100%;
		flex-grow: 1;
		z-index: 505;
		border-top: #ea4335 solid 2px;
	}

</style>
